import { render, staticRenderFns } from "./UpdateOfferingAccess.vue?vue&type=template&id=7b60e6aa&scoped=true&"
import script from "./UpdateOfferingAccess.vue?vue&type=script&lang=js&"
export * from "./UpdateOfferingAccess.vue?vue&type=script&lang=js&"
import style0 from "./UpdateOfferingAccess.vue?vue&type=style&index=0&id=7b60e6aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b60e6aa",
  null
  
)

export default component.exports